import { localize } from "../../i18n";
import { STRING } from "../../i18n/base";

export const validateBodyShapeBustStep = (profile, config) => {
  // BodyShapeBust;

  if (validateBodyShapeBust(profile.bustOffset)) {
    return false;
  }
  return true;
};

export const validateBodyShapeBust = (value) => {
  if (value === "") {
    return localize(STRING.REQUIRED, {
      fieldName: localize(STRING.BUST),
    });
  }
  return false;
};
